import React from "react";
import {
  Home,
  User,
  Lightbulb,
  FolderKanban,
  Mail,
  ArrowUpRight,
} from "lucide-react";

function Header({ setCurrentPage, currentPage }) {
  const navItems = [
    { name: "Home", icon: Home, page: "home" },
    { name: "About", icon: User, page: "about" },
    { name: "Skills", icon: Lightbulb, page: "skills" },
    { name: "Projects", icon: FolderKanban, page: "projects" },
    { name: "Contact", icon: Mail, page: "contact" },
  ];

  return (
    <header className="t-header t-shell">
      <button
        className="t-logo"
        onClick={() => setCurrentPage("home")}
        aria-label="Go to home"
      >
        Taelo<small>.DEV</small>
      </button>

      <nav className="t-nav" aria-label="Main">
        {navItems.map((item) => (
          <button
            key={item.page}
            onClick={() => setCurrentPage(item.page)}
            className={`t-nav__link ${
              currentPage === item.page ? "is-active" : ""
            }`}
            aria-current={currentPage === item.page ? "page" : undefined}
            aria-label={item.name}
          >
            <item.icon size={18} className="t-nav__icon" />
            <span className="t-nav__label">{item.name}</span>
          </button>
        ))}
      </nav>

      <button
        className="t-btn t-btn--sm t-header__cta"
        onClick={() => setCurrentPage("contact")}
      >
        Hire me <ArrowUpRight size={14} />
      </button>
    </header>
  );
}

export default Header;
